import { useQueries } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const getAccountRoleInPartner = async ({
  partnerId,
  accountId,
  makeRequest,
}: {
  partnerId: string;
  accountId: string;
  makeRequest: ImperativeRequestFn;
}): Promise<string | null> => {
  const { data, error } = await makeRequest({
    path: `/admin/partners/${partnerId}/accounts/${accountId}`,
  });

  if (error || !data) {
    throw new Error(error ?? 'Failed to fetch account role for partner');
  }

  return data.role?.name ?? null;
};

export const useGetAccountRolesInPartners = ({
  accountId,
  partnerIds,
}: {
  accountId: string;
  partnerIds: string[];
}) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillage');

  return useQueries({
    queries: partnerIds.map((partnerId) => ({
      queryKey: ['account-role-in-partner', partnerId, accountId],
      queryFn: () =>
        getAccountRoleInPartner({ partnerId, accountId, makeRequest }),
      enabled: !!partnerId && !!accountId,
    })),
  });
};
